import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8tj4junats: FaireBrandEntity = {
  token: "b_8tj4junats",
  type: "brand",
  name: "Effing Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/786e1a588ca15c9c5d5990855530886212910c963bcf4bd870aad6c97eee0731.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1fa9b1492ba1324d3fdc8f60d2cf129c5e63640290cff140d2f83fc3c04e618d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/786e1a588ca15c9c5d5990855530886212910c963bcf4bd870aad6c97eee0731.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1fa9b1492ba1324d3fdc8f60d2cf129c5e63640290cff140d2f83fc3c04e618d.jpeg",
  location: "Kansas City, MO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi! I'm Birdie, the CEO and Founder of Effing Candle Co. We're a women-owned, LGBTQIA+ candle brand that hand-pours non-toxic candles in Kansas City, MO. All of our products are made with non-toxic apricot coconut wax, fine fragrance and essential oils, and FSC-Certified crackling wooden wicks. Our 7.2oz jars burn for ~50 hours. Travel candles burn for 20-25 hours.\n\nOur cheeky labels make customers pick our candles off the shelves, and the burn quality keeps them coming back. The perfect opening order is 12+ jars (4 fragrances x 3+ units of each) + 24 travel candles (four fragrances x 6 units of each). We recommend choosing the jar and travel candle for each scent. This allows customers to choose their price point. \n\nI'm a former ad agency gal, and I want to help support your store on social media, our website, direct mail, employee training, gratis, and signage. I hope you won't be a stranger. The ease of faceless ordering on Faire is great, but real relationships are built through connections. I look forward to connecting with you! ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:56.605Z",
    importedBy: "entity-db-cli",
  },
};
